import { useEffect, useCallback, useState } from "react";
import { paths } from "src/routes/paths";
import { useAuthData } from "../firebase/AuthProvider";
import { useRouter } from "src/hooks/useRouter";

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const router = useRouter();

  const { authenticated, emailVerified } = useAuthData();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      //not login
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const loginPath = paths.auth.login;

      const href = `${loginPath}?${searchParams}`;

      router.replace(href);
    } else {
      if (!emailVerified) {
        setChecked(true);
      } else {
        router.replace(paths.dashboard.root);
      }
    }
  }, [authenticated, router]);

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
